const KIT_CONTROL = 'input, textarea, button, a, [tabindex]';

/**
 * Focuses what `find` returns, and for a ph-* tag the control inside its shadow
 * root, since focusing the host itself lands nowhere. React fills that shadow
 * root a few frames after Angular renders the host, so this retries each frame
 * until the control exists, then gives up on the host. A tag that is not a
 * defined custom element will never draw one, so it gets the host at once.
 */
export function focusWhenMounted(find: () => HTMLElement | null, frames = 20): void {
    const found = find();
    const tag = found?.tagName.toLowerCase() ?? '';
    const isTag = tag.startsWith('ph-') && !!customElements.get(tag);
    const target = isTag ? found?.shadowRoot?.querySelector<HTMLElement>(KIT_CONTROL) : found;
    if (target) {
        target.focus();
    } else if (frames > 0) {
        requestAnimationFrame(() => focusWhenMounted(find, frames - 1));
    } else {
        found?.focus();
    }
}
